(function() {
	const $reviewApp 	= document.querySelector('.review-app');
	const $contentBlock = document.getElementById('content');

	const stickyReviewApp = function() {
		if ( window.innerWidth < 768 ) {
			return true;
		}

		if ( window.pageYOffset + 20 > $reviewApp.parentElement.offsetTop ) {
			if ( ! $reviewApp.classList.contains('sticky') ) {
				$reviewApp.classList.add('sticky');
			}

			const maxStickyOffset = $contentBlock.offsetHeight + $contentBlock.offsetTop - $reviewApp.offsetHeight;

			if ( window.pageYOffset >= maxStickyOffset ) {
				$reviewApp.style.transform = `translateY(${maxStickyOffset - window.pageYOffset}px)`;
			} else {
				$reviewApp.removeAttribute('style');
			}
		} else {
			if ( $reviewApp.classList.contains('sticky')  ) {
				$reviewApp.classList.remove('sticky');
			}
		}
	};

	const unStickyReviewApp = function() {
		if ( window.innerWidth < 768 ) {
			if ( $reviewApp.classList.contains('sticky')  ) {
				$reviewApp.classList.remove('sticky');
			}
		} else {
			stickyReviewApp();
		}
	};

	if ( $reviewApp ) {
		stickyReviewApp();

		window.addEventListener('scroll', stickyReviewApp);
		window.addEventListener('resize', unStickyReviewApp);
		window.addEventListener('orientationchange', unStickyReviewApp);
	}

	const calcInputtedComment = function() {
		document.querySelector('.input-counter').innerText = this.value.length;
	};

	document.addEventListener('input', function(e) {
		const target = e.target;

		if ( 'comment' === target.name ) {
			calcInputtedComment.call(target);
		}
	});

	document.addEventListener('submit', function(e) {
		const target = e.target;

		if ( 'commentform' === target.id ) {
			const checkedRating = document.querySelector('input[name="rating"]:checked');

				if ( checkedRating ) {
					console.log(+checkedRating.value);
				}
		}
	});

	const TOCBlock			= document.querySelector('.ez-toc');
	const TOCList			= $('.ez-toc-list').first();
	const TOCBlockWrapper	= document.querySelector('.review-app-wrapper');
	const contentSection	= document.querySelector('.section--content');

	if ( TOCBlock && TOCBlockWrapper && contentSection && TOCList.length ) {
		window.addEventListener('scroll', function() {
			const activeLink = TOCBlock.querySelector('.active');

			if ( window.innerWidth >= 768 ) {
				if ( TOCBlock.classList.contains('fixed') ) {
					TOCBlock.classList.remove('fixed');
				}

				if ( activeLink ) {
					TOCList.stop().animate({
						scrollTop: activeLink.offsetTop - activeLink.parentElement.offsetTop
					}, 100);
				}

				return true;
			}

			const TOCBlockHeight		= 50;

			const topStickyEdge		= TOCBlockWrapper.getBoundingClientRect().top + TOCBlockWrapper.offsetHeight - TOCBlockHeight;
			const bottomStickyEdge	= contentSection.offsetTop + contentSection.offsetHeight - TOCBlockHeight;

			if ( topStickyEdge <= 0 ) {
				if ( ! TOCBlock.classList.contains('fixed') ) {
					TOCBlock.classList.add('fixed');
				}

				if ( window.pageYOffset > bottomStickyEdge ) {
					if ( ! TOCBlock.classList.contains('fixed-hide') ) {
						TOCBlock.classList.add('fixed-hide');
					}
				} else if ( TOCBlock.classList.contains('fixed-hide') ) {
					TOCBlock.classList.remove('fixed-hide');
				}
			} else if ( TOCBlock.classList.contains('fixed') ) {
				TOCBlock.classList.remove('fixed');
			}

			if ( activeLink ) {
				TOCList.stop().animate({
					scrollLeft: activeLink.offsetLeft - 14
				}, 100);
			}
		}, { passive: true });
	}

	const affiliateDisclosure = document.querySelector('.aff-disclosure');
	if ( affiliateDisclosure ) {
		affiliateDisclosure.addEventListener('click', function(e) {
			e.stopPropagation();

			if ( e.target.classList.contains('aff-disclosure') ) {
				this.classList.toggle('open');
			}
		}, { passive: true });

		document.body.addEventListener('click', function() {
			affiliateDisclosure.classList.remove('open');
		}, { passive: true });
	}
})();

(function($, $document) {
	const $reviewFilterForm = $('form#review-filter-form').first();
	const $reviewsCards		= $('#reviews-cards').first();
	const $appliedFilters	= $('.applied-filters').first();

	$document.on('click', '.load-more-comments', function() {
		const $this = $(this);

		$.get(
			RSA.ajaxurl,
			{
				action: 'rsa_load_more_comments',
				paged: $this.attr('data-paged'),
				postID: $this.attr('data-post-id'),
				nonce: RSA.nonce,
			}, function(response) {
				$this.parent().replaceWith(response);
			}, 'html');
	});

	const showAppliedFilters = function() {
		const $appliedItems = $('.dropdown-filter input:checked');
		let filtersMarkup	= '';

		if ( $appliedItems.length ) {
			$appliedItems.each(function(item) {
				const $input = $(this);

				if ( $input.attr('name') === 'sortby' ) {
					return;
				}

				const idAttr = $input.attr('id');
				filtersMarkup = `<button type="button" id="filter-${idAttr}" class="applied-item clear-filter" data-selector="#${$input.attr('id')}">${$input.next('label').text()}</button>`;
			});

			if ( filtersMarkup ) {
				$appliedFilters
					.append(filtersMarkup)
					.slideDown();
			}
		}
	};

	showAppliedFilters();

	const autoCloseOpenedElements = function() {
		$('.open').removeClass('open');
	};

	if ( $reviewFilterForm.length ) {
		let isLoaderActive = true;
		const loadReviews = function() {
			$reviewsCards.addClass('loading');
			$.get(RSA.ajaxurl + '?' + $reviewFilterForm.serialize(), {action: 'rsa_filter_reviews', nonce: RSA.nonce}, function(response) {
				$reviewsCards.html(response).removeClass('loading');
			});

			isLoaderActive = true;
		};

		const applyFilters = function(e) {
			e.preventDefault();
			if ( ! isLoaderActive ) {
				return;
			}

			loadReviews();
		};

		const maybeCloseApplyiedFilters = function() {
			const $appliedFiltersItems = $('.clear-filter');

			if ( ! $appliedFiltersItems.length ) {
				$appliedFilters.slideUp();
			}
		};

		$reviewFilterForm.on('submit', applyFilters);

		$reviewFilterForm.on('reset', function() {
			$('.dropdown-filter .counter').text('').hide();
			isLoaderActive = false;
			$appliedFilters.slideUp().find('.clear-filter').trigger('click').remove();
			loadReviews();
		});

		const _changeFilterHandler = function(e) {
			const $this = $(this);
			const activeOptions = $this.find('input:checked').length;
			const $input = $(e.target);
			const idAttr = $input.attr('id');

			if ( $this.hasClass('dropdown-filter--radio') ) {
				if ( $input.is(':checked') ) {
					const $item = $(`<button type="button" id="filter-${$input.attr('name')}" class="applied-item clear-filter clear-radio" data-selector="${$input.attr('name')}">${$input.next('label').text()}</button>`);
					const $temp = $(`#filter-${$input.attr('name')}`);

					$this.find('.dropdown-filter__label').text($input.next('label').text());

					if ( $temp.length ) {
						$temp.replaceWith($item);
					} else {
						$appliedFilters.append($item);
					}

					$appliedFilters.slideDown()
				} else {
					$(`#filter-${idAttr}`).remove();
				}
			} else {
				if ( $input.is(':checked') ) {
					$appliedFilters
						.slideDown()
						.append(`<button type="button" id="filter-${idAttr}" class="applied-item clear-filter" data-selector="#${$input.attr('id')}">${$input.next('label').text()}</button>`);
				} else {
					$(`#filter-${idAttr}`).remove();
				}

				if ( 0 === activeOptions ) {
					$this.find('.counter').text('').fadeOut();
				} else {
					$this.find('.counter').text(activeOptions).fadeIn();
				}
			}

			maybeCloseApplyiedFilters();
			$reviewFilterForm.trigger('submit');
		};

		$document.on('change', '.dropdown-filter', function(e) {
			if ( window.innerWidth >= 576 ) {
				_changeFilterHandler.call(this, e);
			}
		});

		let activeInputsInFilter = [];

		$document.on('click', '.apply-mobile', function() {
			if ( window.innerWidth >= 576 ) {
				return true;
			}

			const $appliedFilters = $('.applied-filters').first();
			let activeFiltersNumber = 0;

			$appliedFilters.find('.clear-filter').remove();

			$('.dropdown-filter').each(function() {
				const $this = $(this);

				let numb = 0;

				$this.find('input:checked').each(function() {
					numb++;

					const $input = $(this);
					const idAttr = $input.attr('id');

					$appliedFilters
						.append(`<button type="button" id="filter-${idAttr}" class="applied-item clear-filter" data-selector="#${idAttr}">${$input.next('label').text()}</button>`);
				});

				activeFiltersNumber += numb;

				if ( $this.hasClass('sort-filter') ) {
					return;
				}

				if ( 0 === numb ) {
					$this.find('.counter').text('').fadeOut();
				} else {
					$this.find('.counter').text(numb).fadeIn();
				}
			});


			if ( activeFiltersNumber ) {
				$appliedFilters.slideDown();
			} else {
				$appliedFilters.slideUp();
			}

			maybeCloseApplyiedFilters();
			autoCloseOpenedElements();
			$reviewFilterForm.trigger('submit');
		});

		$document.on('click', '.clear-filter', function() {
			const $this = $(this);
			let $target = null;

			if ( $this.hasClass('clear-radio') ) {
				$target = $(`input[name="${$this.attr('data-selector')}"]`);
				const $label = $target.closest('.dropdown-filter').find('.dropdown-filter__label');
				$label.text($label.attr('data-text'));
			} else {
				$target = $($this.attr('data-selector'));
			}

			$target.prop('checked', false);

			if ( window.innerWidth < 576 ) {
				const $activeFilters = $target.closest('.dropdown-filter').find('input:checked');

				if ( $activeFilters.length ) {
					$target.closest('.dropdown-filter').find('.counter').text($activeFilters.length).fadeIn();
				} else {
					$target.closest('.dropdown-filter').find('.counter').text('').fadeOut();
				}

				$reviewFilterForm.trigger('submit');
			} else {
				$target.trigger('change');
			}

			$this.remove();
			maybeCloseApplyiedFilters();
		});

		const _desktopFilterChangeHandler = function() {
			const $filter = $(this).closest('.dropdown-filter');

			if ( $filter.hasClass('open') ) {
				$filter.removeClass('open');
			} else {
				autoCloseOpenedElements();
				$filter.addClass('open');
			}
		};

		const _mobileFilterChangeHandler = function() {
			const $filter = $(this).closest('.dropdown-filter');

			$filter.find('input:checked').each(function() {
				activeInputsInFilter.push($(this).attr('id'));
			});

			autoCloseOpenedElements();
			$filter.addClass('open')
		};

		$document.on('click', '.dropdown-filter__label', function() {
			if ( window.innerWidth >= 576 ) {
				_desktopFilterChangeHandler.call(this);
			} else {
				_mobileFilterChangeHandler.call(this);
			}
		});

		$document.on('click' ,'.close-filter-mobile', function() {
			const $filter = $(this).closest('.dropdown-filter');

			$filter.find('input').each(function() {
				const $this = $(this);
				$this.prop('checked', -1 !== activeInputsInFilter.indexOf($this.attr('id')) );
			});

			activeInputsInFilter = [];
			$filter.removeClass('open');
		});

		$document.on('click', '.dropdown-filter', function(e) {
			e.stopPropagation();
		});
		$document.on('click', autoCloseOpenedElements);
	}
})(jQuery, jQuery(document));
